var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.davPath)?_c('VuePlyr',{ref:"plyr",style:({
		height: _vm.height + 'px',
		width: _vm.width + 'px'
	}),attrs:{"options":_vm.options}},[_c('video',{ref:"video",attrs:{"autoplay":_vm.active,"playsinline":true,"poster":_vm.livePhotoPath,"src":_vm.davPath,"preload":"metadata"},on:{"ended":_vm.donePlaying,"canplay":_vm.doneLoading,"loadedmetadata":_vm.onLoadedMetadata}},[_vm._v("\n\n\t\t"+_vm._s(_vm.t('viewer', 'Your browser does not support videos.'))+"\n\t")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }